import { FC } from 'react'
import { SvgProps } from './svgProps'

const JacketIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width || 32}
    height={height || 32}
    viewBox="0 0 32 32"
  >
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M10.409 0.419h10.35"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M22.741 28.81c0.722-0.641 1.174-1.571 1.174-2.607 0-0.001 0-0.001 0-0.002v0-4.526"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M7.781 21.675v4.526c0 0.001 0 0.002 0 0.003 0 1.026 0.444 1.948 1.15 2.584l0.003 0.003"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M23.909 22.258v-4.052c0-1.137 0.038-2.324 0.086-2.643s0.468 1.453 0.677 2.569l2.133 10.277c0.147 0.881 0.904 1.545 1.816 1.545 0.188 0 0.369-0.028 0.54-0.081l-0.013 0.003 0.285-0.082c0.947-0.306 1.62-1.179 1.62-2.21 0-0.136-0.012-0.269-0.034-0.398l0.002 0.014-3.89-19.937c-0.21-1.118-0.784-2.232-1.29-2.477-0.419-0.21-3.356-1.659-4.717-2.175"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M10.539 2.626c-1.367 0.52-4.272 1.961-4.683 2.162-0.505 0.245-1.049 1.181-1.218 2.078-0.138 0.759-3.968 20.343-3.968 20.343-0.020 0.116-0.032 0.249-0.032 0.384 0 1.031 0.673 1.904 1.603 2.205l0.016 0.005 0.285 0.082c0.158 0.049 0.339 0.077 0.527 0.077 0.912 0 1.669-0.664 1.814-1.534l0.001-0.011 2.133-10.277c0.21-1.116 0.468-2.276 0.573-2.578s0.191 1.514 0.191 2.649v4.857"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M3.647 29.865l-0.573 1.716-2.655-0.91 0.602-1.804"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M28.030 29.865l0.573 1.716 2.655-0.91-0.602-1.804"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M11.134 2.936c-1.678-0.778-1.659-1.328-1.401-1.9s0.65-0.954 2.334-0.176 4.018 2.416 3.76 2.989-3.010-0.138-4.694-0.912z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M20.509 2.936c1.678-0.778 1.659-1.328 1.401-1.9s-0.65-0.954-2.334-0.176-4.018 2.416-3.76 2.989 3.010-0.138 4.694-0.912z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M15.828 3.848v24.943"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M8.867 28.867h13.924v2.066h-13.924v-2.066z"
    ></path>
  </svg>
)

export default JacketIcon
